@if (waitingForFilterResults) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="list-header">
  <h1 class="page-title">{{ entityTypeName }}</h1>

  <div class="filter-container">
    <mat-button-toggle-group
      (change)="userChangedFilter($event)"
      multiple="true">
      <mat-button-toggle
        value="Owner"
        [checked]="isFilterActive(MyWorkFilter.Owner)">
        I am the Owner
      </mat-button-toggle>
      <mat-button-toggle
        value="ExpiringSoon"
        [checked]="isFilterActive(MyWorkFilter.ExpiringSoon)">
        Expiring Soon (6 months)
      </mat-button-toggle>
      <mat-button-toggle
        value="Expired"
        [checked]="isFilterActive(MyWorkFilter.Expired)">
        Already Expired
      </mat-button-toggle>
      <mat-button-toggle
        value="NextReviewDateSoon"
        [checked]="isFilterActive(MyWorkFilter.NextReviewDateSoon)">
        Next Review Date Soon (6 months)
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <span class="item-count">{{ filteredCois.length }} COIs</span>
</div>

<div class="table-container">
  <table mat-table [dataSource]="filteredCois" matSort (matSortChange)="sortData($event)" class="entity-table">

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let coi" class="status-cell">
        @if (isExpired(coi)) {
          <mat-icon class="status-icon expired" matTooltip="Expired">error</mat-icon>
        } @else if (isExpiringSoon(coi)) {
          <mat-icon class="status-icon expiring-soon" matTooltip="Expiring within 6 months">warning</mat-icon>
        } @else {
          <mat-icon class="status-icon active" matTooltip="Active">check_circle</mat-icon>
        }
      </td>
    </ng-container>

    <!-- Insured Party Column -->
    <ng-container matColumnDef="insuredPartyFriendlyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Insured Party</th>
      <td mat-cell *matCellDef="let coi" class="name-cell">
        <span class="coi-name">{{ getInsuredPartyName(coi) || '—' }}</span>
        @if (coi.coiId) {
          <span class="coi-id-badge">{{ coi.coiId }}</span>
        }
      </td>
    </ng-container>

    <!-- Coverage Types Column -->
    <ng-container matColumnDef="coverageTypes">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Coverage Types</th>
      <td mat-cell *matCellDef="let coi">{{ formatCoverageTypes(coi.coverageTypes) }}</td>
    </ng-container>

    <!-- Primary Owner Column -->
    <ng-container matColumnDef="primaryOwner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary Owner</th>
      <td mat-cell *matCellDef="let coi">{{ getPrimaryOwnerName(coi) }}</td>
    </ng-container>

    <!-- Expiration Date Column -->
    <ng-container matColumnDef="expirationDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
      <td mat-cell *matCellDef="let coi"
          [class.overdue-text]="isExpired(coi)"
          [class.due-soon-text]="isExpiringSoon(coi) && !isExpired(coi)">
        {{ formatDate(coi.expirationDate) }}
      </td>
    </ng-container>

    <!-- Insurance Carrier Column -->
    <ng-container matColumnDef="insuranceProviderNameDisplay">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Insurance Carrier</th>
      <td mat-cell *matCellDef="let coi">{{ getInsuranceProviderName(coi) }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="entity-row"
        (click)="onRowClicked(row)">
    </tr>

    <!-- No data row -->
    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-data-message">
          @if (isLoading) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Loading COIs...</p>
          } @else {
            <mat-icon>shield</mat-icon>
            <p>No certificates of insurance found</p>
          }
        </div>
      </td>
    </tr>
  </table>
</div>
